/**
 * @generated SignedSource<<9db7486dbdb82e6771666070474c0ab1>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitiesFilter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scheduleTemplateId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "entitiesFilter",
            "variableName": "entitiesFilter"
        },
        {
            "kind": "Variable",
            "name": "scheduleTemplateId",
            "variableName": "scheduleTemplateId"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleTemplatePeriod",
        "kind": "LinkedField",
        "name": "period",
        "plural": false,
        "selections": [
            (v2 /*: any*/)
        ],
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleTemplateInformationPeriodScheduleTimesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ScheduleTimesByTemplatePeriodPayload",
                    "kind": "LinkedField",
                    "name": "scheduleTemplateTimesPerPeriod",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleTemplatePeriodTimes",
                            "kind": "LinkedField",
                            "name": "periods",
                            "plural": true,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "ScheduleTimesPayload_iHaveScheduleTimes"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleTemplateInformationPeriodScheduleTimesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ScheduleTimesByTemplatePeriodPayload",
                    "kind": "LinkedField",
                    "name": "scheduleTemplateTimesPerPeriod",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleTemplatePeriodTimes",
                            "kind": "LinkedField",
                            "name": "periods",
                            "plural": true,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTimeByEntityAndAssignmentType",
                                            "kind": "LinkedField",
                                            "name": "timesByEntityAndAssignmentType",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CalculateTimePartsPayload",
                                                    "kind": "LinkedField",
                                                    "name": "calculatedTimes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "employmentSummaries",
                                                            "args": null,
                                                            "concreteType": "CalculateTimePartsSummaryByEmployment",
                                                            "kind": "LinkedField",
                                                            "name": "summaryByEmployment",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Employment",
                                                                    "kind": "LinkedField",
                                                                    "name": "employment",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EmploymentSetting",
                                                                            "kind": "LinkedField",
                                                                            "name": "employmentSetting",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": "eventSummaries",
                                                                    "args": null,
                                                                    "concreteType": "TimePartsSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "calculatedSummary",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isWork",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeSpecificationPartSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "nonRegularPartsSummary",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "unit",
                                                                                            "value": "SECOND"
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "TimeSpanUnitValue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "duration",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v5 /*: any*/),
                                                                                        (v6 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": "duration(unit:\"SECOND\")"
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v6 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "IHaveScheduleTimes",
                                    "abstractKey": "__isIHaveScheduleTimes"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "366231f3a57970135c3c4ff1e15b027b",
            "id": null,
            "metadata": {},
            "name": "ScheduleTemplateInformationPeriodScheduleTimesQuery",
            "operationKind": "query",
            "text": "query ScheduleTemplateInformationPeriodScheduleTimesQuery(\n  $entitiesFilter: ScheduleTemplateShiftFilterRequestInput\n  $scheduleTemplateId: ID!\n) {\n  scheduleTemplateTimesPerPeriod(entitiesFilter: $entitiesFilter, scheduleTemplateId: $scheduleTemplateId) {\n    periods {\n      period {\n        id\n      }\n      ...ScheduleTimesPayload_iHaveScheduleTimes\n    }\n  }\n}\n\nfragment ScheduleTimesPayload_iHaveScheduleTimes on IHaveScheduleTimes {\n  __isIHaveScheduleTimes: __typename\n  timesByEntityAndAssignmentType {\n    calculatedTimes {\n      employmentSummaries: summaryByEmployment {\n        employment {\n          employmentSetting {\n            title\n            id\n          }\n          id\n        }\n        eventSummaries: calculatedSummary {\n          event {\n            id\n            name\n          }\n          isWork\n          nonRegularPartsSummary {\n            event {\n              id\n              name\n            }\n            duration(unit: SECOND) {\n              value\n              unit\n            }\n          }\n          unit\n          value\n        }\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "b84fd1e76928837c48f51d661c11f4bc";
export default node;
